import { withLifeErrorBoundary } from '@festina-life/components'
import type { Optional } from '@festina-life/core'
import { FPlusCodeEditor } from '@festina-life/fplus'
import type { FPlusClientDiagnostic } from '@festina-life/fplus-monaco'
import { withSuspense } from '@festina-life/ui/libs'

import { useFPlusCodeEditorContext } from '../../uiModels/fplus/useFPlusCodeEditorContext'

type Props = {
  /**
   * Original code shown in the editor, without formatting.
   */
  code: string
  expressionPath: string
  onChangeErrors?: (nextErrors: FPlusClientDiagnostic[]) => void
  onChangeCode: (nextValue: string) => void
  prefixFunctionDeclaration: Optional<string>
}

const FPlusEditorInternal = ({
  code,
  expressionPath,
  onChangeCode,
  onChangeErrors,
  prefixFunctionDeclaration,
}: Props) => {
  const languageServerContext = useFPlusCodeEditorContext({
    expressionPath,
    prefixFunctionDeclaration,
  })

  return (
    <div className="h-[40vh]">
      <FPlusCodeEditor
        initialCode={code}
        onChangeCode={onChangeCode}
        onChangeErrors={onChangeErrors}
        editorInput={languageServerContext}
      />
    </div>
  )
}

export const FPlusEditor = withSuspense(
  withLifeErrorBoundary(FPlusEditorInternal),
)
